export const TooltipKeys = {
	CameraHomeButton: "cameraHomeButton", 
	CameraFocusButton: "cameraFocusButton", 
	CameraPerspective: "CameraPerspective", 
	CameraOrthographic: "CameraOrthographic",
	CameraFocusPoint: "CameraFocusPoint",
	HierarchyTriangleCount: "HierarchyTriangleCount", 
	HierarchyDescendantCount: "HierarchyDescendantCount", 
	HierarchyVisibilityMode: "HierarchyVisibilityMode", 
	HierarchyObjectEntry: "HierarchyObjectEntry",
	RevisionNodeTriangleCount: "RevisionNodeTriangleCount", 
	RevisionNodeDescendantCount: "RevisionNodeDescendantCount", 
	RevisionNodeLevel: "RevisionNodeLevel", 
	RevisionTargetLow: "RevisionTargetLow", 
	RevisionTargetMedium: "RevisionTargetMedium", 
	RevisionTargetHigh: "RevisionTargetHigh",
	TimelineRecordStop: "TimelineRecordStop", 
	TimelineRecordStart: "TimelineRecordStart", 
	TimelineGotoStart: "TimelineGotoStart", 
	TimelineGotoPreviousBarStart: "TimelineGotoPreviousBarStart", 
	TimelineGotoPreviousFrame: "TimelineGotoPreviousFrame", 
	TimelinePlaybackStart: "TimelinePlaybackStart", 
	TimelinePlaybackPause: "TimelinePlaybackPause", 
	TimelineGotoNextFrame: "TimelineGotoNextFrame", 
	TimelineGotoNextBarEnd: "TimelineGotoNextBarEnd", 
	TimelineGotoEnd: "TimelineGotoEnd", 
	TimelineElementInspectorClose: "TimelineElementInspectorClose", 
	TimelineFragment: "TimelineFragment", 
	TimelineChannel: "TimelineChannel", 
	TimelineActionTrack: "TimelineActionTrack",
	TimelineObject: "TimelineObject", 
	TimelineTimestrip: "TimelineTimestrip", 
	TimelineAddChannel: "timelineAddChannel", 
	TimelineAddTimebar: "timelineAddTimebar", 
	TimelineFrameInputStart: "TimelineFrameInputStart", 
	TimelineFrameInputEnd: "TimelineFrameInputEnd", 
	TimelineTrackbox: "TimelineTrackbox", 
	TimelineAddSelected: "TimelineAddSelected",
	TimelineAddAction: "TimelineAddAction",
	ScrollbarResizer: "ScrollbarResizer", 
	ScrollbarArrow: "ScrollbarArrow",
	DesktopWindowExpand: "DesktopWindowExpand", 
	DesktopWindowMinimize: "DesktopWindowMinimize", 
	DesktopWindowClose: "DesktopWindowClose", 
	DesktopWindowHeader: "DesktopWindowHeader",
	SearchFieldClear: "SearchFieldClear",
	GizmoHidden: "GizmoHidden", 
	GizmoMove: "GizmoMove", 
	GizmoRotate: "GizmoRotate", 
	GizmoScale: "GizmoScale", 
	GizmoPivotGroup: "GizmoPivotGroup", 
	GizmoPivotObject: "GizmoPivotObject", 
	GizmoSpaceWorld: "GizmoSpaceWorld", 
	GizmoSpaceLocal: "GizmoSpaceLocal", 
	GizmoFreeMoveMode: "GizmoFreeMoveMode",
	TranslateWithoutChildren: "TranslateWithoutChildren",
	AlignBoundsLeft: "BoundsLeft", 
	AlignBoundsRight: "BoundsRight", 
	AlignBoundsBottom: "BoundsBottom", 
	AlignBoundsTop: "BoundsTop", 
	AlignBoundsBack: "BoundsBack", 
	AlignBoundsFront: "BoundsFront", 
	AlignBoundsX: "BoundsX", 
	AlignBoundsY: "BoundsY", 
	AlignBoundsZ: "BoundsZ", 
	AlignAxisX: "AlignAxisX", 
	AlignAxisY: "AlignAxisY", 
	AlignAxisZ: "AlignAxisZ",
	SimulationStart: "SimulationStart", 
	SimulationStop: "SimulationStop",
	AssetLibraryPreviewSizeInput: "AssetLibraryPreviewSizeInput", 
	AssetListFolder: "AssetListFolder", 
	AssetListModelProcessed: "AssetListModelProcessed", 
	AssetListModelError: "AssetListModelError", 
	AssteListModelProcessing: "AssteListModelProcessing", 
	AssetListImage: "AssetListImage", 
	AssetListVideo: "AssetListVideo", 
	AssetListAudio: "AssetListAudio",
	AssetListUITemplate: "AssetListUITemplate",
	AssetListMaterial: "AssetListMaterial",
	AssetListDocument: "AssetListDocument",
	AssetLibraryUsedAssets: "AssetLibraryUsedAssets", 
	AssetLibraryScenarioAssets: "AssetLibraryScenarioAssets", 
	AssetLibraryUserAssets: "AssetLibraryUserAssets", 
	AssetLibraryOrganizationAssets: "AssetLibraryOrganizationAssets", 
	AssetPickerSetFromLibrary: "AssetPickerSetFromLibrary", 
	AssetPickerClear: "AssetPickerClear", 
	AssetPickerSelectInLibrary: "AssetPickerSelectInLibrary", 
	SequencePickerGoToContentPlacement: "SequencePickerGoToContentPlacement", 
	AssetStatusTriCountHigh: "AssetStatusTriCountHigh", 
	AssetStatusTriCountMed: "AssetStatusTriCountMed", 
	AssetStatusTriCountLow: "AssetStatusTriCountLow", 
	AssetStatusChildHigh: "AssetStatusChildHigh", 
	AssetStatusChildMed: "AssetStatusChildMed", 
	AssetStatusChildLow: "AssetStatusChildLow",
	ScenarioNameInput: "ScenarioNameInput", 
	ScenarioShare: "ScenarioShare", 
	ScenarioPublish: "ScenarioPublish",
	ScenarioPublishGroupsUsersInfo: "ScenarioPublishGroupsUsersInfo",
	AddSequenceButton: "AddSequenceButton", 
	AddStepButton: "AddStepButton", 
	SequenceEditorSequenceBoxIn: "SequenceEditorSequenceBoxIn", 
	SequenceEditorBackgroundGrid: "SequenceEditorBackgroundGrid", 
	SequenceEditorSequenceBoxOut: "SequenceEditorSequenceBoxOut", 
	SequenceEditorSequenceBox: "SequenceEditorSequenceBox", 
	SequenceEditorStepBox: "SequenceEditorStepBox", 
	SequenceEditorDefaultStateBox: "SequenceEditorDefaultStateBox", 
	ContentPlacementStep: "ContentPlacementStep",
	UndoStackEntry: "UndoStackEntry",
	ObjectGroupsEntry: "ObjectGroupsEntry", 
	ObjectGroupsEntrySubObject: "ObjectGroupsEntrySubObject",
	ARTrackerEntry: "ARTrackerEntry",
	InvertZoom: "InvertZoom",
	PreferencesEnableDialog: "PreferencesMoveAssetDialog",
	PreferencesFirstClickSelectsParent: "PreferencesFirstClickSelectsParent",
	KeybindingsAssignButton: "KeybindingsAssignButton",
	PropertyGroupHeader: "PropertyGroupHeader", 
	NumberPropertyInteractions: "NumberPropertyInteractions", 
	NumberPropertyDragLabelInteractions: "NumberPropertyWithDragLabelInteractions",
	ViewGrid: "ViewGrid", 
	ViewSprites: "ViewSprites", 
	ViewTrackers: "ViewTrackers", 
	SelectionBoxOnTop: "SelectionBoxOnTop", 
	ViewUI: "ViewUI",
	RenderModeStandalone: "RenderModeStandalone", 
	RenderModeOverlay: "RenderModeDevice", 
	StandaloneModeProperty: "StandaloneModeProperty", 
	OverlayModeProperty: "DeviceModeProperty",
	AutosaveGeneral: "AutosaveGeneral", 
	AutosaveOnOff: "AutosaveOnOff", 
	SaveError: "SaveError", 
	SaveInProgress: "SaveInProgress", 
	SaveSuccessful: "SaveSuccessful", 
	AutosaveIntervalInput: "AutosaveIntervalInput", 
	SettingsSyncPending: "SettingsSyncPending", 
	SettingsSyncInProgress: "SettingsSyncInProgress", 
	SettingsSyncError: "SettingsSyncError", 
	SettingsSyncSuccess: "SettingsSyncSuccess",
	NotificationDismiss: "NotificationDismiss",
	AddSceneViewButton: "AddSceneViewButton",
	ExpandSceneViewHorizontal: "ExpandSceneViewHorizontal", 
	ExpandSceneViewVertical: "ExpandSceneViewVertical",
	SplitSceneViewHorizontal: "SplitSceneViewHorizontal", 
	SplitSceneViewVertical: "SplitSceneViewVertical",
	fileDownloadStatus: "fileDownloadStatus", 
	fileUploadStatus: "fileUploadStatus",
	FPSDisplay: "FPSDisplay", 
	TriangleCountDisplay: "TriangleCountDisplay",
	ObjectCountDisplay: "ObjectCountDisplay",
	ScenarioPublishOriginGroup: "ScenarioPublishOriginGroup",
	ObjectTrackerAutoPose: "ObjectTrackerAutoPose", 
	ObjectTrackerInlierRatio: "ObjectTrackerInlierRatioInitiation", 
	ObjectTrackerInlierRatioMinimum: "ObjectTrackerInlierRatioMinimum", 
	ObjectTrackerLaplaceThreshold: "ObjectTrackerLaplaceThreshold", 
	ObjectTrackerNormalThreshold: "ObjectTrackerNormalThreshold", 
	ObjectTrackerKeyframeDistance: "ObjectTrackerKeyframeDistance", 
	ObjectTrackerLineGradientThreshold: "ObjectTrackerLineGradientThreshold", 
	ObjectTrackerLineSearchLengthInit: "ObjectTrackerLineSearchLengthInit", 
	ObjectTrackerLineSearchLengthTracking: "ObjectTrackerLineSearchLengthTracking",
	ObjectTrackerFovPercent: "ObjectTrackerFovPercent",
	SnapSettingsMenu: "SnapSettingsMenu",
	AlignToSceneView: "AlignToSceneView",
	CalloutCsvImport: "CalloutCsvImport",
	RBOPImport: "RBOPImport",
	QuizSettingsShowCorrectAnswers: "QuizSettingsShowCorrectAnswers",
	UIVoice: "UIVoice",
	SyncWithDefaultState: "SyncWithDefaultState",
	ApplyToSceneView: "ApplyToSceneView",
	GrapesJSFitCanvas: "GrapesJSFitCanvas",
	GrapesJSShowViewport: "GrapesJSShowViewport",
	VisageTemplateEditorBanner: "VisageTemplateEditorBanner",
	EditTemplateDisabled: "EditTemplateDisabled",
	HelpAndResources: "HelpAndResources",
	sharedAsset: "sharedAsset",
	VisagePropertyShadowBlur: "VisagePropertyShadowBlur",
	VisagePropertyShadowSpread: "VisagePropertyShadowSpread",
	VisageCameraLayers: "VisageCameraLayers",
	VisageAddLayoutProperty: "VisageAddLayoutProperty",
	VisageAddStyleProperty: "VisageAddStyleProperty",
	VisageHorizontalSizeType : "VisageHorizontalSizeType",
	VisageVerticalSizeType : "VisageVerticalSizeType",
	VisageConstrainProportions : "VisageConstrainProportions",
	VisageSizeTypeFixed : "VisageSizeTypeFixed",
	VisageSizeTypeAuto : "VisageSizeTypeAuto",
	VisageSizeTypeFill : "VisageSizeTypeFill",
	VisageFlexVertical : "VisageFlexVertical",
	VisageFlexHorizontal : "VisageFlexHorizontal",
	VisageFlexGrid : "VisageFlexGrid",
	VisageFlexTopLeft : "VisageFlexTopLeft",
	VisageFlexTopCenter : "VisageFlexTopCenter",
	VisageFlexTopRight : "VisageFlexTopRight",
	VisageFlexCenterLeft : "VisageFlexCenterLeft",
	VisageFlexCenter : "VisageFlexCenter",
	VisageFlexCenterRight : "VisageFlexCenterRight",
	VisageFlexBottomLeft : "VisageFlexBottomLeft",
	VisageFlexBottomCenter : "VisageFlexBottomCenter",
	VisageFlexBottomRight : "VisageFlexBottomRight",
	VisageVerticalPadding : "VisageVerticalPadding",
	VisageHorizontalPadding : "VisageHorizontalPadding",
	VisageIndividualPadding : "VisageIndividualPadding",
	VisageAbsolutePositionAnchorTopLeft : "VisageAbsolutePositionAnchorTopLeft",
	VisageAbsolutePositionAnchorTopCenter : "VisageAbsolutePositionAnchorTopCenter",
	VisageAbsolutePositionAnchorTopRight : "VisageAbsolutePositionAnchorTopRight",
	VisageAbsolutePositionAnchorCenterLeft : "VisageAbsolutePositionAnchorCenterLeft",
	VisageAbsolutePositionAnchorCenter : "VisageAbsolutePositionAnchorCenter",
	VisageAbsolutePositionAnchorCenterRight : "VisageAbsolutePositionAnchorCenterRight",
	VisageAbsolutePositionAnchorBottomLeft : "VisageAbsolutePositionAnchorBottomLeft",
	VisageAbsolutePositionAnchorBottomCenter : "VisageAbsolutePositionAnchorBottomCenter",
	VisageAbsolutePositionAnchorBottomRight : "VisageAbsolutePositionAnchorBottomRight",
	VisageMarginTop : "VisageMarginTop",
	VisageMarginBottom : "VisageMarginBottom",
	VisageMarginLeft : "VisageMarginLeft",
	VisageMarginRight : "VisageMarginRight",
	VisageScrollingHorizontal : "VisageScrollingHorizontal",
	VisageScrollingVertical : "VisageScrollingVertical",
	VisageFillTypeNone : "VisageFillTypeNone",
	VisageFillTypeSolid : "VisageFillTypeSolid",
	VisageFillTypeGradient : "VisageFillTypeGradient",
	VisageFillTypeImage : "VisageFillTypeImage",
	VisagePaddingHeader: "VisagePaddingHeader",
	VisageAbsoloutePositionHeader : "VisageAbsoloutePositionHeader",
	VisagePageHierarchyHeader : "VisagePageHierarchyHeader",
	VisageFlexHeader: "VisageFlexHeader",
	VisageAutomaticMode: "VisageAutomaticMode",
	VisageSmartIdentifier: "VisageSmartIdentifier",
	RbopMerge: "RbopMerge",
	WebappScenarioCannotLoad: "WebappScenarioCannotLoad",
	Text3DUnsupportedTags: "Text3DUnsupportedTags",
	productVersion: "productVersion",
	SceneStatusDefaultState: "SceneStatusDefaultState",
	SceneStatusBeforeCPS: "SceneStatusBeforeCPS",
	SceneStatusQuizGradedKnowledge: "SceneStatusQuizGradedKnowledge",
	SceneStatusQuizGradedNoResults: "SceneStatusQuizGradedNoResults",
	SceneStatusQuizResultsStepQuestions: "SceneStatusQuizResultsStepQuestions",
	SceneStatusQuizSequenceNoResult: "SceneStatusQuizSequenceNoResult",
	RestoreDefaultValues: "RestoreDefaultValues",
	
	// Editor Preferences
	PreferencesAutoSaveEnabled: "PreferencesAutoSaveEnabled",
	PreferencesAutoSaveInterval: "PreferencesAutoSaveInterval",
	PreferencesSkipDialogSetApprovedState: "PreferencesSkipDialogSetApprovedState",
	PreferencesSkipDialogSetRequestChangesState: "PreferencesSkipDialogSetRequestChangesState",
	PreferencesEnableDialogMoveAsset: "PreferencesEnableDialogMoveAsset",
	PreferencesEnableDialogDeleteAsset: "PreferencesEnableDialogDeleteAsset",
	PreferencesWelcomeScreenOpeningPageView: "PreferencesWelcomeScreenOpeningPageView",
	PreferencesWelcomeScreenLastSortDetails: "PreferencesWelcomeScreenLastSortDetails",
	PreferencesUnitDisplay: "PreferencesUnitDisplay",
	PreferencesImageImportHeight: "PreferencesImageImportHeight",
	PreferencesVideoImportHeight: "PreferencesVideoImportHeight",
	PreferencesEnableTooltips: "PreferencesEnableTooltips",
	PreferencesBoundsInformationEnabled: "PreferencesBoundsInformationEnabled",
	PreferencesBoundsInformationPrecision: "PreferencesBoundsInformationPrecision",
	PreferencesRenderDefaultBackground: "PreferencesRenderDefaultBackground",
	PreferencesViewportBackgroundColor: "PreferencesViewportBackgroundColor",
	PreferencesInvertZoom: "PreferencesInvertZoom",
	PreferencesSceneViewSelectChildren: "PreferencesSceneViewSelectChildren",
	PreferencesSceneViewFirstClickSelectsParent: "PreferencesSceneViewFirstClickSelectsParent",
	PreferencesDefaultTimelineLength: "PreferencesDefaultTimelineLength",
	PreferencesDefaultTimebarLength: "PreferencesDefaultTimebarLength",
	PreferencesDefaultHighlightSphereColor: "PreferencesDefaultHighlightSphereColor",
	PreferencesDefaultHighlightSphereSize: "PreferencesDefaultHighlightSphereSize",
	PreferencesDefaultSetObjectColor: "PreferencesDefaultSetObjectColor",
	PreferencesDefaultCalloutScale: "PreferencesDefaultCalloutScale",
	PreferencesDefaultCalloutOffset: "PreferencesDefaultCalloutOffset",
	PreferencesShowSequenceConnections: "PreferencesShowSequenceConnections",
	PreferencesShowHeadersConnections: "PreferencesShowHeadersConnections",
	PreferencesShowOptionsConnections: "PreferencesShowOptionsConnections",
	PreferencesShowInsetsConnections: "PreferencesShowInsetsConnections",
	PreferencesShowCancelConnections: "PreferencesShowCancelConnections",
	PreferencesShowConnectionsFlow: "PreferencesShowConnectionsFlow",
	PreferencesNewProjectEnvironment: "PreferencesNewProjectEnvironment",
	PreferencesAiCompanionPrompts: "PreferencesAiCompanionPrompts",
	PreferencesAiCompanionSelectedPromptIndex: "PreferencesAiCompanionSelectedPromptIndex",	
};
